import React from 'react';
import PropTypes from 'prop-types';
import ShowComponent from '../../hocs/ShowComponent';

@ShowComponent
class PrimaryButton extends React.Component {
  constructor(props) {
    super(props);

    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler(e) {
    e.preventDefault();
    this.props.onClickHandler(e);
  }

  render() {
    const { href, text, disabled, classNames, title } = this.props;

    const disabledClassName = disabled ? 'disabled-link' : '';

    return (
      <a
        href={href}
        className={`primary-submit-button ${disabledClassName} ${classNames}`}
        onClick={this.onClickHandler}
        disabled={disabled}
        title={title}
      >
        {text}
      </a>
    );
  }
}

PrimaryButton.propTypes = {
  href: PropTypes.string,
  classNames: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClickHandler: PropTypes.func,
  disabled: PropTypes.bool,
};

PrimaryButton.defaultProps = {
  href: '',
  classNames: '',
  onClickHandler: () => {},
  disabled: false,
};

export default PrimaryButton;

